export const COUNT_LINE_COLOR = "#6366f1"
export const READY_DELAYS_MS = [100, 500]

export function chartJsFor(chartId) {
  return window.Chartkick?.charts?.[chartId]?.chart || null
}

export function scheduleWhenReady(chartId, callback, timeouts) {
  let succeeded = false
  const run = () => {
    if (succeeded) return
    if (!chartJsFor(chartId)) return
    if (callback() === false) return

    succeeded = true
  }

  run()
  READY_DELAYS_MS.forEach((ms) => {
    timeouts.push(setTimeout(run, ms))
  })
}

export function injectCountLine(chart, {label, values}) {
  if (!chart?.data) return

  const existing = chart.data.datasets.find((dataset) => dataset.label === label)
  if (existing) {
    existing.data = values
    existing.type = "line"
    existing.yAxisID = "y1"
    existing.borderColor = COUNT_LINE_COLOR
    existing.pointBackgroundColor = COUNT_LINE_COLOR
  } else {
    chart.data.datasets.push({
      label,
      data: values,
      type: "line",
      yAxisID: "y1",
      borderColor: COUNT_LINE_COLOR,
      borderWidth: 2,
      pointRadius: 3,
      pointBackgroundColor: COUNT_LINE_COLOR,
      fill: false,
      tension: 0.3,
      order: 0,
    })
  }

  if (chart.options?.scales?.y?.ticks) {
    chart.options.scales.y.ticks.callback = (value) => `${value}%`
  }
  chart.update()
}
